type BannerColor = 'yellow' | 'orange' | 'blue' | 'green' | 'red';

interface BannerProps {
  color: BannerColor;
  icon: JSX.Element;
  text: JSX.Element;
  className?: string;
}

const BASE_STYLES = 'w-full flex items-center gap-4 p-4 rounded-[1rem]';

const BANNER_COLOR_TO_STYLES: Record<BannerColor, string> = {
  yellow: `${BASE_STYLES} bg-[#fff9f3] first:!text-[#cb6d0e] border-[#ffdcb9] border-2`,
  blue: '',
  orange: '',
  green: `${BASE_STYLES} bg-[#f3faf7] first:!text-[#2e7d32] border-[#b9f2d8] border-2`,
  red: '',
};

export const Banner = ({ color, icon, text, className }: BannerProps) => {
  return (
    <div className={className}>
      <div className={BANNER_COLOR_TO_STYLES[color]}>
        <div>{icon}</div>
        <div className="text-text-secondary">{text}</div>
      </div>
    </div>
  );
};
